// extracted by mini-css-extract-plugin
export default {"tableflow":"Tableflow_tableflow__Gf2Ep","small":"Tableflow_small__oHfzK","normal":"Tableflow_normal__Ima1H","big":"Tableflow_big__mc8Un"};